import React, { Component } from "react";
import { components } from "react-select";
import { Modal, Form, Col, Button, Card, Container, Row } from "react-bootstrap";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import moment from "moment";

const ADD_ATTENDANCE = gql`
  mutation($params: EmployeeAttendance) {
    addEmployeeAttendanceData(params: $params)
  }
`;

class SubmitAttendanceModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentStep: 1,
            submitError: "",
            loadingSpinner: 0,
        };
    }

    handleFormSubmit = e => {

        e.preventDefault();
        let employeeDetails = [];
        this.props.stateData.getEmployeesAttendanceStatus.map((item) => {
            employeeDetails.push({ employee_id: item.employee_id, attendance_status: parseInt(item.value) })
        })
        let params = {
            inserted_time: moment(this.props.stateData.date, 'YYYY-MM-DD').unix().toString(),
            employee_attendance: employeeDetails,
        };
        console.log("params", params);

        this.addEmployeeAttendanceData(params).catch(error => {

            this.setState({
                submitError: error.graphQLErrors.map(x => x.message)
            });

            setTimeout(() => {
                this.props.onHide();
            }, 5000);
        });
    };

    addEmployeeAttendanceData = async params => {
        await this.props.addEmployeeAttendanceData({
            variables: {
                params
            },
            update: (store, { data }) => {
                if (data.addEmployeeAttendanceData) {
                    this.setState({
                        loadingSpinner: 1,
                        currentStep: 5,
                    });

                    setTimeout(() => {
                        this.SetpageLoad();
                    }, 1500);
                }
            }
        });
    };

    SetpageLoad = () => {
        this.setState({ currentStep: 1, submitError: "", loadingSpinner: 0 });
        this.props.onHide();
        window.location.reload(false)
    };

    render() {
        return (
            <Modal
                {...this.props}
                size="md"
                aria-labelledby="example-modal-sizes-title-lg"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Employee Attendance confirmation</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-4">
                    <Row>
                        <Col>
                            <h4>Total Employees :</h4>
                        </Col>
                        <Col>
                            <h4>{this.props.stateData.totalEmployees}</h4>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <h6>Total Present :</h6>
                        </Col>
                        <Col>
                            <h6>{this.props.stateData.presentEmployees}</h6>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <h6>Total Absent :</h6>
                        </Col>
                        <Col>
                            <h6>{this.props.stateData.absentEmployees} </h6>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <h6>Half Day Total :</h6>
                        </Col>
                        <Col>
                            <h6>{this.props.stateData.halfDayEmployees} </h6>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer variant="white" className="px-4">
                    <Row>
                        <Col sm={12}>
                            {this.state.currentStep == 5 ? (
                                <Form.Text className="form-text text-danger mb-2 " style={{ textAlign: "center" }}>
                                    Attendance added successfully
                                </Form.Text>
                            ) : (
                                <Form.Text className="form-text text-danger mb-2" style={{ textAlign: "center", display: "none" }}>
                                    {this.state.submitError}
                                </Form.Text>
                            )}
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={12} >

                            <Button onClick={this.handleFormSubmit} style={{ backgroundColor: "#213046", border: "1px solid #213046" }} type="submit" inline>
                                {
                                    this.state.loadingSpinner == 1 ? (
                                        <span className="spinner-border spinner-border-sm"></span>
                                    ) : ""
                                }
                                CONFIRM</Button>

                        </Col>
                    </Row>
                </Modal.Footer>
            </Modal>
        );
    }
}


export default graphql(ADD_ATTENDANCE, {
    name: "addEmployeeAttendanceData"
})(SubmitAttendanceModal);


